export default "__VITE_ASSET__aLa3BGlB__"